import { Link } from "react-router-dom";
import { PRODUCTS, SERVICES_LIST, COMPANY } from "@/data/content";
import { useSite } from "@/context/SiteContext";

const CompanyLinks = [
  { label: "About Us", to: "/about" }, { label: "Brands", to: "/brands" },
  { label: "Projects", to: "/projects" }, { label: "Resources", to: "/resources" },
  { label: "Contact Us", to: "/contact" }, { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Data Deletion", to: "/data-deletion" }, { label: "Terms & Conditions", to: "/terms" },
];

export default function Footer() {
  const { config } = useSite();
  const val = (k, fallback) => (config && config[k]) || fallback;
  // Phase 11: brand identity from the live /api/config (per-deployment
  // SITE_ID), falling back to the existing Hindustan Solar Power defaults.
  const brandName = config?.brand || COMPANY.name;
  const logoSrc = config?.logo || "/logo.jpeg";
  const domain = config?.domain || COMPANY.domain;
  const tagline = config?.tagline || COMPANY.tagline;
  const positioning = config?.positioning || "Complete Solar, Energy Storage & Power Solutions";
  return (
    <footer className="bg-[#03070A] border-t border-emerald-900/40 text-slate-400 pt-16 pb-28 lg:pb-16" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="col-span-2">
            <div className="bg-white rounded-lg p-2 inline-flex mb-3"><img src={logoSrc} alt={`${brandName} logo`} className="h-16 lg:h-28 w-auto" /></div>
            <div className="text-emerald-400 text-sm font-mono">{positioning}</div>
            <p className="text-sm mt-4 max-w-sm leading-relaxed">{tagline}. Serving customers, dealers, EPC companies, institutions and government organizations across India.</p>
            <div className="mt-5 space-y-1.5 text-sm">
              <div><span className="text-slate-500">Address:</span> {val("address", "[ENTER ACTUAL ADDRESS]")}</div>
              <div><span className="text-slate-500">Phone:</span> {val("phone", "[ENTER ACTUAL PHONE NUMBER]")}</div>
              <div><span className="text-slate-500">Email:</span> {val("email", "[ENTER ACTUAL EMAIL]")}</div>
              <div><span className="text-slate-500">GST:</span> {val("gst", "[ENTER ACTUAL GST]")}</div>
              <div><span className="text-slate-500">Hours:</span> {val("business_hours", "[ENTER BUSINESS HOURS]")}</div>
            </div>
          </div>
          <div>
            <div className="mono-label mb-4">Products</div>
            <ul className="space-y-2 text-sm">
              {PRODUCTS.slice(0, 8).map((p) => (
                <li key={p.slug}><Link to={`/products/${p.slug}`} className="hover:text-emerald-400 transition-colors">{p.name}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <div className="mono-label mb-4">Services</div>
            <ul className="space-y-2 text-sm">
              {SERVICES_LIST.slice(0, 8).map((s) => (
                <li key={s}><Link to="/solutions" className="hover:text-emerald-400 transition-colors">{s}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <div className="mono-label mb-4">Company</div>
            <ul className="space-y-2 text-sm">
              {CompanyLinks.map((c, i) => (
                <li key={i}><Link to={c.to} className="hover:text-emerald-400 transition-colors">{c.label}</Link></li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} {brandName}. All rights reserved.</div>
          <div>{domain}</div>
        </div>
      </div>
    </footer>
  );
}
